export default "__VITE_ASSET__Mg1W3bvK__"